import { useQuery } from "react-query";

import { getRequests } from "../../../../../MyApi/sb/requests";
import { getEmployes } from "../../../../../MyApi/sb/employes";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addCurrency.module.css";

const AddEmployeRequest = ({
  setRequestId,
  setNote,
  setEmployId,
  setHoursCount,
  setAmount,
  setDateFrom,
  setDaysCount,
  setTimeTo,
  setDateTo,
  setTimeFrom,
  amount,
  setImage,
  date_from,
  date_to,
  time_to,
  time_from,
  image,
  hours_count,
  days_count,
  note,
  fileImageRef,
}) => {
  const requestQuery = useQuery("getRequests", getRequests);
  const employeQuery = useQuery("getEmployes", getEmployes);

  const requests = requestQuery.data?.data || [];
  const employes = employeQuery.data?.data || [];


  const DateIcon = icons.date;
  const ImageIcon =icons.image
  const RequestIcon =icons.request
  const EmployeIcon = icons.employ
  const TimeIcon =icons.timer
  const NoteIcon = icons.note
  const AmountIcon = icons.amount
  const DaysIcon = icons.days
  
  const handleRequestIdChange = (e) => {
    setRequestId(e.target.options[e.target.selectedIndex].id);
  };
  const handleEmployeIdChange = (e) => {
    setEmployId(e.target.options[e.target.selectedIndex].id);
  };
  const handleNoteChange = (e) => {
    const { value } = e.target;
    setNote(value);
  };
  const handleHoursCountChange = (e) => {
    const { value } = e.target;
    setHoursCount(value);
  };
  const handleDateFrom = (e) => {
    const { value } = e.target;
    setDateFrom(value);
  };
  const handleDateTo = (e) => {
    const { value } = e.target;
    setDateTo(value);
  };
  const handleTimeTo = (e) => {
    const { value } = e.target;
    setTimeTo(value);
  };
  const handleTimeFrom = (e) => {
    const { value } = e.target;
    setTimeFrom(value);
  };
  const handleAmountChange = (e) => {
    const { value } = e.target;
    const doubleAmount = parseFloat(value).toFixed(3);
    setAmount(value);
  };
  const handleDaysCount = (e) => {
    const { value } = e.target;
    setDaysCount(value);
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];


    setImage(file);
  };
  if (requestQuery.isLoading || requestQuery.isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="row mb-3">
      <div className="col-lg-6">
        <div className={classes.formCard}>
          <div className={classes.formGrid}>
            <div className={classes.formCol}>
              <label htmlFor="">الطلبات </label>
              <div className={classes.iconInput}>
                <RequestIcon />
              </div>
              {!requestQuery.data ? (
                <div> no data available </div>
              ) : (
                <select
                  type="text"
                  onChange={handleRequestIdChange}
                  className={classes.inputCustom}>
                  <option value="اختار الطلبات">اختار الطلبات</option>
                  {requests.map((request) => (
                    <option id={request.id} value={request.name}>
                      {request.name}
                    </option>
                  ))}
                </select>
              )}
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">الموظفين </label>
              <div className={classes.iconInput}>
                <EmployeIcon />
              </div>
              {!employeQuery.data ? (
                <div> no data available </div>
              ) : (
                <select
                  type="text"
                  onChange={handleEmployeIdChange}
                  className={classes.inputCustom}>
                  <option value="اختار الموظفين">اختار الموظفين</option>
                  {employes.map((employe) => (
                    <option id={employe.id} value={employe.name_ar}>
                      {employe.name_ar}
                    </option>
                  ))}
                </select>
              )}
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">الملاحظات </label>
              <div className={classes.iconInput}>
                <NoteIcon />
              </div>
              <textarea
                type="textarea"
                placeholder="ادخل  الملاحظه"
                onChange={handleNoteChange}
                value={note}
                className={classes.inputCustom}>
                {" "}
              </textarea>
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">الكمية </label>
              <div className={classes.iconInput}>
                <AmountIcon />
              </div>
              <input
                type="number"
                placeholder="ادخل  الكمية"
                onChange={handleAmountChange}
                value={amount}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">الوقت من </label>
              <div className={classes.iconInput}>
                <TimeIcon />
              </div>
              <input
                type="time"
                placeholder="ادخل  الوقت من "
                onChange={handleTimeFrom}
                value={time_from}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">الوقت إلي </label>
              <div className={classes.iconInput}>
                <TimeIcon />
              </div>
              <input
                type="time"
                placeholder="ادخل  الوقت إلي "
                onChange={handleTimeTo}
                value={time_to}
                className={classes.inputCustom}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-6"> 
        <div className={classes.formCard}>
        <div className={classes.formGrid}>
         
            <div className={classes.formCol}>
              <label htmlFor="">التاريخ من </label>
              <div className={classes.iconInput}>
                <DateIcon />
              </div>
              <input
                type="date"
                placeholder="ادخل التاريخ من "
                onChange={handleDateFrom}
                value={date_from}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">التاريخ إلي </label>
              <div className={classes.iconInput}>
                <DateIcon />
              </div>
              <input
                type="date"
                placeholder="ادخل التاريخ إلي "
                onChange={handleDateTo}
                value={date_to}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="image"> الصورة </label>
              <div className={classes.iconInput}>
                <ImageIcon />
              </div>
              <input
                type="file"
                ref={fileImageRef}
                placeholder="ادخل الصورة "
                onChange={handleImageChange}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="hoursCount"> عدد الساعات </label>
              <div className={classes.iconInput}>
                <TimeIcon />
              </div>
              <input
                type="number"
                placeholder="ادخل عدد الساعات "
                onChange={handleHoursCountChange}
                value={hours_count}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="dayscount"> عدد الايام </label>
              <div className={classes.iconInput}>
                <DaysIcon />
              </div>
              <input
                type="number"
                placeholder="ادخل عدد الايام "
                onChange={handleDaysCount}
                value={days_count}
                className={classes.inputCustom}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEmployeRequest;
